import { MockPushButton } from './MockPushButton';

export const MockControls = () => {
  if (process.env.MOCKED_READER !== 'true') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        padding: 20,
        background: '#f0f0f0',
        borderRadius: 8,
        zIndex: 1000,
      }}
    >
      <h3>Mock Controls</h3>
      <MockPushButton />
    </div>
  );
};
